import { Player } from '@lottiefiles/react-lottie-player'
import React from 'react'

const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 0.5,
}

const LottieAnimation = ({ src, style, ...rest }) => (
    <Player style={style} src={src} {...defaultOptions} {...rest} />
)

export default LottieAnimation
